import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  margin: 40px 0 50px;

  .tracking-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2 {
    color: ${palette("color", 15)};
    text-align: center;
  }

  p {
    text-align: center;
    padding-bottom: 10px;
  }
`;
